import styled from 'styled-components';
import media from '../../constants/media';

export const Wrapper = styled.div``;

export const TabContentWrapper = styled.div`
	margin: 3rem 0;

	${media.desktopSmall`
		margin: 6rem 0;
	`};
`;
